import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { Divider } from '@ui-kitten/components'
import moment from 'moment'
import { DiscountOffer } from '@src/screens/Marketplace/components/checkout/DiscountOffer'
import { OrderSummary } from '@src/screens/Marketplace/components/checkout/OrderSummary'
import { calculateDiscount } from '@src/screens/Marketplace/utils/utils'
import { PaymentMethodCard } from '@src/screens/Marketplace/components/checkout/PaymentMethodCard'
import { BillingProduct, PromotionCode } from '@src/types'
import { userSelector } from '@src/selectors/app'
import { ORDER_SUMMARY_DATE_FORMAT } from '@src/config/momentFormat'
import { StyleService, useStyleSheet } from '@src/style/service'

interface ProductPaymentProps {
  product: BillingProduct
  trialDays?: number
  estimatedTax: number
  fullPrice: number
  promotionCode: PromotionCode | null
  additionalDiscount?: number
}

export const ProductPayment = ({
  product,
  trialDays,
  estimatedTax,
  fullPrice,
  promotionCode,
  additionalDiscount = 0,
}: ProductPaymentProps) => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()
  const user = useSelector(userSelector)
  const paymentMethod = user?.paymentMethod

  const onEditPromotionCode = () => {
    navigation.navigate('DiscountCode', { product })
  }

  const onEditPaymentMethodPress = () => {
    navigation.navigate('CreatePaymentMethod')
  }

  const promotionCodeDiscount = calculateDiscount(fullPrice, promotionCode)
  const discount = promotionCodeDiscount + additionalDiscount
  const discountedPrice = fullPrice - discount
  const chargeDate = trialDays
    ? moment().add(trialDays, 'days').format(ORDER_SUMMARY_DATE_FORMAT)
    : moment().format(ORDER_SUMMARY_DATE_FORMAT)

  return (
    <>
      <DiscountOffer code={promotionCode} onEditPromotionCode={onEditPromotionCode} />
      <Divider appearance="large" />
      <OrderSummary
        price={fullPrice}
        discount={discount}
        estimatedTax={discountedPrice > 0 ? estimatedTax : 0}
        chargeDate={chargeDate}
        style={styles.orderSummary}
      />
      <Divider appearance="large" />
      <PaymentMethodCard
        paymentMethod={paymentMethod}
        style={styles.paymentMethod}
        onEditPaymentMethodPress={onEditPaymentMethodPress}
      />
    </>
  )
}

const themedStyle = StyleService.create({
  orderSummary: {
    marginHorizontal: 16,
    marginBottom: 16,
  },
  paymentMethod: {
    paddingHorizontal: 16,
  },
})
